export default "/images/31af68d0c95b0c74d5013f1bc7f6173e.jpg";